import { render, staticRenderFns } from "./TalkSymposium.vue?vue&type=template&id=487d2a62&scoped=true&"
import script from "./TalkSymposium.vue?vue&type=script&lang=js&"
export * from "./TalkSymposium.vue?vue&type=script&lang=js&"
import style0 from "./TalkSymposium.vue?vue&type=style&index=0&id=487d2a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d2a62",
  null
  
)

export default component.exports